module.exports = __webpack_public_path__ + "3394d92557e7df44170cdbd5d8906742.svg";